import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Info } from 'lucide-react';

interface RemoveFromStructureDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  costCentreName: string;
  onConfirm: () => void;
}

export function RemoveFromStructureDialog({
  open,
  onOpenChange,
  costCentreName,
  onConfirm,
}: RemoveFromStructureDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <Info className="h-5 w-5 text-info-600" />
            <AlertDialogTitle>Remove from Structure?</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-3 pt-2">
            <p className="font-medium text-foreground">
              Remove '{costCentreName}' from the structure?
            </p>
            <p>
              This cost centre will be removed from the hierarchy but will remain in the project. 
              It will be available in 'Add Existing' to re-add later.
            </p>
            <p>
              All data (budget, actuals, custom fields) will be preserved.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-primary hover:bg-primary/90"
          >
            Remove from Structure
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
